import { ELLIPSIS } from './specialCharacters';

export const truncate = (string: string, maxLength: number): string =>
  !string || string.length <= maxLength
    ? string
    : string.slice(0, maxLength) + ELLIPSIS;
